<template>
	<dms-list-layout v-bind="layoutProps">
		<div slot="filter">
			<dms-row>
				<dms-check :value.sync="Otevrene" :span="8" label-key="chkOtevrene" />
				<dms-check :value.sync="Uvolnene" :span="8" label-key="chkUvolnene" />
				<dms-check :value.sync="Uzavrene" :span="8" label-key="chkUzavrene" />
			</dms-row>
			<dms-row>
				<dms-check :value.sync="SkladVoz" :span="12" label-key="chkSkladVoz" />
				<dms-check :value.sync="KomisVoz" :span="12" label-key="chkKomisVoz" />
			</dms-row>
			<dms-select :select-list="dropdownList.ProvozovnaId" :span="24" :value.sync="ProvozovnaId" label-key="PROVOZOVNA_ID" />
			<dms-input :span="24" :value.sync="KomiseovNr" label-key="KOMISEOV_NR" />
			<dms-group show-label label-key="OVPRIJEMKA_NR">
				<dms-input :span="6" :value.sync="OvprijemkaPfx" placeholder-key="OVPRIJEMKA_PFX" />
				<dms-input :span="18" :value.sync="OvprijemkaNr" placeholder-key="OVPRIJEMKA_NR" />
			</dms-group>
			<dms-input-number :span="24" :value.sync="PovNr" label-key="POV_NR" />
			<dms-group label-key="KAROSERIE_NR">
				<dms-input :value.sync="KaroserieNr" :span="12" label-key="KAROSERIE_NR" />
				<dms-select :select-list="vinSubstrOptions" :value.sync="VinSubstr" :span="12" />
			</dms-group>
			<partner-select :value.sync="ZakaznikId" :text.sync="ZakaznikIdText" :mutation-name="mutationsMappers.zakaznik" label-key="ZAKAZNIK_ID"
				label-key-value="ZAKAZNIK_ID" />
			<dms-date-od-do :value-od.sync="UzavDatOd" :value-do.sync="UzavDatDo" label-key="UZAVRENI_DAT" />
			<dms-group show-label label-key="OVVYDEJKA_NR">
				<dms-input :span="6" :value.sync="OvvydejkaPfx" placeholder-key="OVVYDEJKA_PFX" />
				<dms-input :span="18" :value.sync="OvvydejkaNr" placeholder-key="OVVYDEJKA_NR" />
			</dms-group>
			<dms-group :span="24" show-label label-key="X_DOKLAD_NR">
				<dms-input :span="12" :value.sync="DokladOd" label-key="X_DOKLAD_NR_OD" />
				<dms-input :span="12" :value.sync="DokladDo" label-key="X_DOKLAD_NR_DO" />
			</dms-group>
			<dms-check :value.sync="POVCleared" label-key="cckPoVCleared" />
			<dms-date-od-do :value-od.sync="VstupDatOd" :value-do.sync="VstupDatDo" label-key="VSTUP_DAT" />
			<dms-collapse :value.sync="mainCollapse">
				<dms-collapse-item label-key="Vozidlo" name="1">
					<dms-select :select-list="dropdownList.VyrobekvozOzn" :value.sync="VyrobekvozOzn" label-key="VYROBEKVOZ_OZN" />
					<dms-group label-key="TypkodDMK">
						<dms-input :span="6" :value.sync="DoplnekMk" placeholder-key="DOPLNEK_MK" />
						<typ-select :text.sync="Typkod" :popis.sync="TypkodText" :span="18" :mutation-name="mutationsMappers.typkod" :filter="typkodFilter"
							:validation-off="false" is-popis-visible is-popis-disabled />
					</dms-group>
					<dms-group label-key="KAROSERIE_SERIAL_NR">
						<dms-input :span="12" :value.sync="SerialNrOd">
							<template slot="prepend">
								{{ LocalizePopisostatni("IntervalOd") }}
							</template>
						</dms-input>
						<dms-input :span="12" :value.sync="SerialNrOd">
							<template slot="prepend">
								{{ LocalizePopisostatni("IntervalDo") }}
							</template>
						</dms-input>
					</dms-group>
				</dms-collapse-item>
				<dms-collapse-item label-key="POVStatusy" name="2">
					<dms-check :span="12" :value.sync="KVymazu" label-key="fPOVStatusVY" />
					<dms-check :span="12" :value.sync="NezavazVoz" label-key="fPOVStatusNV" />
					<dms-check :span="12" :value.sync="NezavZaj" label-key="fPOVStatusIN" />
					<dms-check :span="12" :value.sync="ZavazVoz" label-key="fPOVStatusZV" />
					<dms-check :span="12" :value.sync="NezavPopt" label-key="fPOVStatusNP" />
					<dms-check :span="12" :value.sync="UvolnVoz" label-key="fPOVStatusUV" />
					<dms-check :span="12" :value.sync="ZavPopt" label-key="fPOVStatusZP" />
					<dms-check :span="12" :value.sync="ProdaneVoz" label-key="fPOVStatusPV" />
					<dms-check :span="12" :value.sync="BezZak" label-key="fPOVStatusBZ" />
				</dms-collapse-item>
				<dms-collapse-item label-key="OVStatusy" name="3">
					<dms-check :span="12" :value.sync="NeniPrijato" label-key="fOVStatusX" />
					<dms-check :span="12" :value.sync="PrijemKom" label-key="fOVStatusKP" />
					<dms-check :span="12" :value.sync="Naskladneni" label-key="fOVStatusSP" />
					<dms-check :span="12" :value.sync="VKomisi" label-key="fOVStatusKK" />
					<dms-check :span="12" :value.sync="NaSklade" label-key="fOVStatusSS" />
					<dms-check :span="12" :value.sync="Vydano" label-key="fOVStatusKV" />
					<dms-check :span="12" :value.sync="Vyskladneno" label-key="fOVStatusSV" />
				</dms-collapse-item>
			</dms-collapse>
		</div>
		<dms-table slot="content" v-bind="tableModel" v-on="tableListeners" />
	</dms-list-layout>
</template>

<script>
import { Partner } from '@/modules/kartoteka/partner';
import { listFactory } from '@/main/pages';
import { Typ } from '@/modules/ciselnik/dilenske/typ';

import { SubStringRezEnum } from '../constants';
import { NAME } from './constants';
import { listMutations } from './store/types';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect: Partner.components.Select,
		TypSelect: Typ.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				zakaznik: `${this.storeUri}/${listMutations.ZAKAZNIK_SELECT_MAPPER}`,
				typkod: `${this.storeUri}/${listMutations.TYPKOD_SELECT_MAPPER}`,
			};
		},
		typkodFilter() {
			return {
				KaroserieNr: this.KaroserieNr,
				Typkod: this.Typkod,
				VyrobekvozOzn: this.VyrobekvozOzn,
				ZakaznikId: this.ZakaznikId,
			};
		},
		vinSubstrOptions() {
			const enumMembers = Object.keys(SubStringRezEnum).map((key) => SubStringRezEnum[key]);
			const enumKeys = enumMembers.filter((v) => typeof v !== 'number');
			return enumKeys.map((key) => {
				const Value = SubStringRezEnum[key];
				return {
					Disabled: false,
					Text: this.LocalizePopisostatni(`Vinsubstr_rez${Value}`),
					Value,
					Label: undefined,
				};
			});
		},
	},
});
</script>
